import React from 'react';
import { Link } from '@reach/router';
import { connect } from '../../redux/store';
import { compose, withProps } from 'recompose';
import { PageTitle as CommonPageTitle, C } from '@kineticdata/bundle-common';
import { I18n } from '@kineticdata/react';

export const mapStateToProps = state => ({
  space: state.app.space,
});

export const PageTitle = compose(
  connect(mapStateToProps),
  withProps(({ parts = [], breadcrumbs, ...props }) => ({
    parts: parts.concat([[C.SETTINGS_LABEL].filter(Boolean).join(' ')]),
    breadcrumbs: Array.isArray(breadcrumbs)
      ? [
          {
            label: (
              <span>
                <span className="fa fa-fw fa-md fa-arrow-left text-muted" />
                <I18n>{C.SETTINGS_LABEL}</I18n>
              </span>
            ),
            to: '/settings',
          },
        ].concat(breadcrumbs)
      : breadcrumbs,
  })),
)(props => <CommonPageTitle {...props} components={{ Link }} />);
